<template>
    <div class="row">
        <div class="col-sm"><div class="pd-y-20 pd-x-20 bg4 rounded-20">
            <div class="d-flex pd-l-20">
                <img :src="`${myResBaseUrl}v4-assets/img1.png`" />
                <div class="mg-l-30">
                    <div class="mg-y-20 tx-20">Сайн уу, <b>{{$store.state.user.userInfo.fullName}}</b></div>
                    <div style="color: #002e46">Танд <span class="tx-primary tx-semibold">{{new Date() | moment('YYYY')}} онд</span> үзэж дуусах ёстой <span class="tx-primary tx-semibold">{{(mustJoinCourses.all-mustJoinCourses.finished)}}</span> хичээл байна. <br />Та өнөөдрийн байдлаар нийт <span class="tx-primary tx-semibold">{{mustJoinCourses.finished}}</span> хичээл үзэж дууссан байна. Өдрийг сайхан өнгөрүүлээрэй.</div>
                </div>
            </div>
            
        </div>
    </div>
    </div>
</template>
<script>
export default {
    props:{
      mustJoinCourses: {
        type: Object,
        default: () => {},
      },
    },
    data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted(){
  }
}
</script>
<style scoped lang="less">
.bg4{
    position: relative;
    background: rgba(212, 244, 252, 1);
    overflow: hidden;
    &::before{
        content: '';
        background: #c3edfc;
        width: 120px;
        height: 120px;
        position: absolute;
        left: -40px;
        top: -60px;
        border-radius: 50%;
    }
    &::after{
        content: '';
        background: #c3edfc;
        width: 120px;
        height: 120px;
        position: absolute;
        right: -40px;
        bottom: -60px;
        border-radius: 50%;
    }
}
</style>